import { render, staticRenderFns } from "./look-for-group-form.vue?vue&type=template&id=207fceb3&scoped=true&lang=pug&"
import script from "./look-for-group-form.vue?vue&type=script&lang=js&"
export * from "./look-for-group-form.vue?vue&type=script&lang=js&"
import style0 from "./look-for-group-form.vue?vue&type=style&index=0&id=207fceb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207fceb3",
  null
  
)

export default component.exports